import type { Message, Session, Part, SnapshotFileDiff, SessionStatus, ProviderListResponse } from "@opencode-ai/sdk/v2"
import { createSimpleContext } from "./helper"
import { PreloadMultiFileDiffResult } from "@pierre/diffs/ssr"

type Data = {
  agent?: {
    name: string
    color?: string
  }[]
  provider?: ProviderListResponse
  session: Session[]
  session_status: {
    [sessionID: string]: SessionStatus
  }
  session_diff: {
    [sessionID: string]: SnapshotFileDiff[]
  }
  session_diff_preload?: {
    [sessionID: string]: PreloadMultiFileDiffResult<any>[]
  }
  message: {
    [sessionID: string]: Message[]
  }
  part: {
    [messageID: string]: Part[]
  }
}

export type NavigateToSessionFn = (sessionID: string) => void

export type SessionHrefFn = (sessionID: string) => string

// Remove a private project-memory entry (the "undo" on the memory chip). Provided
// by the host app, which owns the SDK; undefined in contexts without a server.
export type ForgetMemoryFn = (memoryID: string) => Promise<void> | void

// Turn Decide's read-only auto-approval off (the «выключить» on an
// auto-approved shell call). Provided by the host app, which owns settings;
// undefined where there are none.
export type DisableAutoApproveFn = () => Promise<void> | void

export const { use: useData, provider: DataProvider } = createSimpleContext({
  name: "Data",
  init: (props: {
    data: Data
    directory: string
    onNavigateToSession?: NavigateToSessionFn
    onSessionHref?: SessionHrefFn
    onForgetMemory?: ForgetMemoryFn
    onDisableAutoApprove?: DisableAutoApproveFn
    /** Experimental: collapse adjacent parallel task parts into one fleet
     * widget (message-part.tsx). Reactive accessor; absent = off. */
    taskGroups?: () => boolean
  }) => {
    return {
      get store() {
        return props.data
      },
      get directory() {
        return props.directory
      },
      navigateToSession: props.onNavigateToSession,
      sessionHref: props.onSessionHref,
      forgetMemory: props.onForgetMemory,
      disableAutoApprove: props.onDisableAutoApprove,
      taskGroups: props.taskGroups,
    }
  },
})
